export enum Breakpoint {
    XSMALL = 375,
    SMALL = 425,
    MEDIUM = 768,
    LARGE = 1024,
    XLARGE = 1260,
    XMLARGE = 1550,
    XXLARGE = 1920
}
